import { useContext, useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { ApiContext, AuthContext, UserContext } from '../App';
import UserRecord from '../records/user';

const options = {
  retry: false
}

export const useLoginWithPassword = () => {
  const api = useContext(ApiContext);

  return useMutation(user => api.post('/admin/auth', user), {
    onError: error => console.log(error)
  })
}

export const useCreateToken = () => {
  const api = useContext(ApiContext);

  return useMutation(user => api.post('/auth/admin', user), {
    onError: error => console.log(error)
  });
}

export const useSetAuth = data => {
  const auth = useContext(AuthContext);
  const user = useContext(UserContext);

  useEffect(() => {
    if (data && data.data) {
      auth.setAuth(data.data.data.data);
      user.setUser(new UserRecord({ ...data.data.data.attributes, is_logged_in: true }));
      window.localStorage.setItem('auth', JSON.stringify(data));
    }
  }, [data, user.user]);
}

export const useImpersonate = () => {
  const api = useContext(ApiContext);

  return useMutation(email => api.post('/admin/impersonate', email), {
    onError: error => console.log(error)
  })
}
